import { render, staticRenderFns } from "./TabScoringDefinition.vue?vue&type=template&id=460f12e9&scoped=true"
import script from "./TabScoringDefinition.vue?vue&type=script&lang=js"
export * from "./TabScoringDefinition.vue?vue&type=script&lang=js"
import style0 from "./TabScoringDefinition.vue?vue&type=style&index=0&id=460f12e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460f12e9",
  null
  
)

export default component.exports